var render = function (_h,_vm) {var _c=_vm._c;return _c('span',_vm._b({staticClass:"cell-bool-icon",class:[_vm.data.staticClass, _vm.props.class]},'span',_vm.data.attrs,false),[(!!_vm.props.value)?_c('decor-icon',{attrs:{"icon":_vm.$options.yes(_vm.props)}}):_c('decor-icon',{attrs:{"icon":_vm.$options.no(_vm.props)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }